import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @param {string} props.icon - Icon name.
 * @param {string} [props.className] - Class(es).
 * @param {object} [props.style] - Style object.
 * @returns {JSX.Element} Component.
 */
export const SvgIcon = ( { icon, className = '', style = {} } ) => (
    <svg className={ className } style={ style }>
        <use
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xlinkHref={ `${ PULSE.app.environment.cdn }i/svg-output/icons.svg#icn-${ icon }` }
        ></use>
    </svg>
);

SvgIcon.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string.isRequired,
    style: PropTypes.object
};